module.exports = __webpack_public_path__ + "static/media/illustration-arbutus-greenway.7a87c213.png";